export const USER_REDUX_RESOURCE_NAME = '__resources';
export const ADVISOR_REDUX_RESOURCE_NAME = '__advisorResources';

// Advisor reducer constants

const ADVISOR_PROFILE = 'advisorProfile';

const ITEMS_BY_ID = 'itemsById';

const DATA = 'data'

// Applicant reducer resources
const REDUX_BORROWERS = 'borrowers';
const REDUX_ACCOUNTS = 'accounts';
const REDUX_APPLICANT_ACCOUNTS = 'applicantAccounts';
const REDUX_LOANAPP = 'loanApp';

const REDUX_EMPLOYMENTS = 'employments';
const REDUX_LENDING_TERMS = 'lendingTermsApplicant';
const REDUX_PROPERTY = 'propertiesApplicant';
const REDUX_LOANAPPROLES = 'loanAppRoles';
const REDUX_COLLATERAL = 'collateral';
const REDUX_DECLARATIONS = 'declarations';

const REDUX_BUSINESS = 'business';
const REDUX_TEAM_MEMBERS = 'teamMembers'
const REDUX_WORKFLOW_INTENTS = 'userSpecificIntent';
const REDUX_REAL_ESTATE_ASSETS = 'realEstateAssets';
const REDUX_LOAN_STATUS = 'loanStatus';
const REDUX_MONTHLY_INCOMES = 'monthlyIncome';
const REDUX_ADDITIONAL_LOANS = 'additionalLoan';
const REDUX_LIABILITIES = 'liabilities';
const REDUX_ASSETS = 'assets';

// Constant we used on workflow config to refer the resource
// Needs to be moved some where else or make same as reducer
const EMPLOYMENT = 'employment'
const BORROWER = 'borrower';
const DECLARATION = 'declaration';
const LENDINGTERMS = 'lendingTerm';
const PROPERTY = 'property';
const LOANAPP_ACCOUNT = 'loanapp_accounts';
const LOAN_STATUS = 'loan_status';
const TEAM_MEMBER = 'team_member'

export {
  BORROWER,
  EMPLOYMENT,
  PROPERTY,
  DECLARATION,
  LENDINGTERMS,
  TEAM_MEMBER,
  LOAN_STATUS,
  LOANAPP_ACCOUNT,
}


export {
  ITEMS_BY_ID,
  REDUX_ACCOUNTS,
  REDUX_BORROWERS,
  REDUX_APPLICANT_ACCOUNTS,
  REDUX_DECLARATIONS,
  REDUX_LOANAPP,
  REDUX_BUSINESS,
  REDUX_TEAM_MEMBERS,
  REDUX_LENDING_TERMS,
  REDUX_PROPERTY,
  REDUX_LOANAPPROLES,
  REDUX_EMPLOYMENTS,
  REDUX_WORKFLOW_INTENTS,
  REDUX_REAL_ESTATE_ASSETS,
  REDUX_LOAN_STATUS,
  REDUX_MONTHLY_INCOMES,
  REDUX_ADDITIONAL_LOANS,
  REDUX_LIABILITIES,
  REDUX_ASSETS,
  REDUX_COLLATERAL,
  DATA,
}

export {
  ADVISOR_PROFILE
}